import React from 'react'
import { IntegrationServiceId } from '../../../common/integrations'
import { ModalIntegrationConnector } from './ModalIntegrationConnectors/ModalIntegrationConnector'
import { DynamicsBasedSSOIntegrationConnector } from './SSOIntegrationConnectors/DynamicsBasedSSOConnector'
import { BaseSSOIntegrationConnector } from './SSOIntegrationConnectors/BaseSSOIntegrationConnector'
import { OutlookCalendarSSOIntegrationConnector } from './SSOIntegrationConnectors/OutlookCalendarSSOIntegrationConnector'

export type IntegrationConnectionProps = {
  serviceId: IntegrationServiceId
  startConnect: boolean
  onConnected: () => void
}

export const IntegrationConnection: React.FC<IntegrationConnectionProps> = ({ serviceId, startConnect, onConnected }) => {
  switch (serviceId) {
    case IntegrationServiceId.PHONE:
    case IntegrationServiceId.EXCHANGE_CALENDAR:
    case IntegrationServiceId.REDTAIL:
    case IntegrationServiceId.SMARTOFFICE:
      return <ModalIntegrationConnector serviceId={serviceId} startConnect={startConnect} onConnected={onConnected} />
    case IntegrationServiceId.ZOOM:
    case IntegrationServiceId.WEBEX:
    case IntegrationServiceId.GOOGLE_CALENDAR:
    case IntegrationServiceId.GMAIL:
    case IntegrationServiceId.OUTLOOK_MAIL:
    case IntegrationServiceId.E_MONEY:
    case IntegrationServiceId.RIGHT_CAPITAL:
    case IntegrationServiceId.ORION:
    case IntegrationServiceId.HOLISTIPLAN:
    case IntegrationServiceId.WEALTHBOX:
    case IntegrationServiceId.HUBSPOT:
    case IntegrationServiceId.SALESFORCE:
    case IntegrationServiceId.PRACTIFI:
    case IntegrationServiceId.XLR8:
    case IntegrationServiceId.BLACK_DIAMOND:
    case IntegrationServiceId.ELEMENTS:
    case IntegrationServiceId.ZOHO:
    case IntegrationServiceId.ADVISOR_ENGINE:
    case IntegrationServiceId.PRECISE_FP:
    case IntegrationServiceId.WEALTH:
      return <BaseSSOIntegrationConnector serviceId={serviceId} startConnect={startConnect} onConnected={onConnected} stateStep={null} />
    case IntegrationServiceId.DYNAMICS:
    case IntegrationServiceId.ENGAGE:
      return <DynamicsBasedSSOIntegrationConnector serviceId={serviceId} startConnect={startConnect} onConnected={onConnected} />
    case IntegrationServiceId.OUTLOOK_CALENDAR:
      return <OutlookCalendarSSOIntegrationConnector serviceId={serviceId} startConnect={startConnect} onConnected={onConnected} />
    default:
      return null
  }
}
